import { useScroll } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Box, Center } from "@chakra-ui/react";
import { motion } from "framer-motion";

export const SNS = () => {
    const { isTablet } = MEDIA();

    const { positionY } = useScroll({ start: "80px", end: "40px" });

    return (
        <Center
            as={motion.div}
            zIndex="9999"
            position="fixed"
            right={isTablet ? "16px" : "48px"}
            w={isTablet ? "48px" : "72px"}
            height={isTablet ? "48px" : "80px"}
            borderRadius={isTablet ? "24px" : "16px"}
            overflow="hidden"
            animate={{
                bottom: positionY,
            }}
        >
            <Box
                w="100%"
                h="100%"
                background={`url(${process.env.PUBLIC_URL}/assets/kakao.png) no-repeat center/cover`}
                cursor="pointer"
                onClick={() => window.open("http://pf.kakao.com/_xmCwGn/chat", "_blank")}
            ></Box>
        </Center>
    );
};
